/**
 * Defines navigation options for the menu. Has no auth. guards as it is presently rendered for internal users only.
 * Auth guards are also defined in the router implementation
 * @returns
 */
export default function () {
	const items: Array<IMenuTreeItem> = [
		{
			label: `Home`,
			items: [
				{ label: `Dashboard`, icon: `pi pi-fw pi-chart-bar`, to: `/` },
				{ label: `Properties`, icon: `pi pi-fw pi-list`, to: `/properties` },
				{ label: `BWOF Emails`, icon: `pi pi-fw pi-inbox`, to: `/outbound-bwof-emails` },
				{ label: `Evac Emails`, icon: `pi pi-fw pi-inbox`, to: `/outbound-evac-emails` },
			]
		},
		{
			label: `Contacts`, icon: ``,
			items: [
				{ label: `All`, icon: `pi pi-fw pi-id-card`, to: `/companies` },
				{ label: `Customers`, icon: `pi pi-fw pi-users`, to: `/customers` },
				{ label: `Suppliers`, icon: `pi pi-fw pi-users`, to: `/suppliers` },
				{ label: `Owners`, icon: `pi pi-fw pi-users`, to: `/owners` },
				{ label: `Mailing list`, icon: `pi pi-fw pi-envelope`, to: `/mailing-list` },
			]
		},
		{
			label: `Admin`, icon: `pi pi-fw pi-sitemap`,
			items: [
				{ label: `Reports`, icon: `pi pi-fw pi-chart-line`, to: `/reports` },
				{ label: "Service Definitions", icon: "pi pi-fw pi-bookmark", to: "/services" },
				{ label: `Users`, icon: `pi pi-fw pi-users`, to: `/users` },
				{ label: "Authorities", icon: "pi pi-fw pi-exclamation-circle", to: "/authorities" },
				{ label: "Customer Logos", icon: "pi pi-fw pi-image", to: "/customer-logos" },
			]
		}
	];

	return items;
}